import { ADD_OBJ_KEY_YO_ARRAY } from "../../../enums/Request/currentRequestControls.types";

export const addObjKeyYoArrayAction = (data) => {
    return {
        type: ADD_OBJ_KEY_YO_ARRAY,
        payload: data,
    };
};
